import { render, staticRenderFns } from "./NovidadeDetailView.vue?vue&type=template&id=fafdf93e&scoped=true&"
import script from "./NovidadeDetailView.vue?vue&type=script&lang=js&"
export * from "./NovidadeDetailView.vue?vue&type=script&lang=js&"
import style0 from "../novidades-detail.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./NovidadeDetailView.vue?vue&type=style&index=1&id=fafdf93e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafdf93e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
